import { Space } from 'antd';
import styled from 'styled-components';
import { BodyLong01 } from 'components/styles';

export const BreadCrumbContainer = styled(Space).attrs({
  align: 'center',
  size: 0,
})`
  ${BodyLong01};
  margin-bottom: var(--spacing-03);
`;
